import axios, {AxiosResponse} from 'axios'
import {Request, Response} from 'express'
import {CurrentUserOutput, GetByUserIdOutput, GetUserByIdOutput, GetUserQuestionsByIdOutput} from './models/userModels'
import {CreateUserWithGroupInput, UpdateNoSisUserInput, UpdateUserInfoInput, UpdateUserQuestionsInput} from './models/userCreateUpdateModels'
import {Result} from '../../resultModel'
import {USERS_CURRENT_USER_GETURL, USERS_CREATEUSERWITHGROUP_POSTURL, USERS_UPDATENOSISUSER_POSTURL, USERS_BY_ID_GETURL, USERS_BY_USERID_GETURL, USERS_UPDATEUSERINFO_POSTURL, USERQUESTIONS_BY_ID_GETURL, USERS_UPDATEUSERQUESTIONS_POSTURL} from '../../endpoints'
import {RequestManager} from '../../RequestManager'

export const getUserByToken = async (token: string) => {
  const requestManager = new RequestManager()

  var res: Result<CurrentUserOutput> = {success: false, message: 'Hata', data: null}
  return requestManager
    .get<Result<CurrentUserOutput>>(USERS_CURRENT_USER_GETURL)
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getByUserId = async (id: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetByUserIdOutput> = {success: false, message: 'Hata', data: null}
  return requestManager
    .get<Result<GetByUserIdOutput>>(USERS_BY_ID_GETURL(id))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getUserQuestionsById = async (id: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetUserQuestionsByIdOutput> = {success: false, message: 'Hata', data: null}
  return requestManager
    .get<Result<GetUserQuestionsByIdOutput>>(USERQUESTIONS_BY_ID_GETURL(id))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getUserByUserId = async (id: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetUserByIdOutput> = {success: false, message: 'Hata', data: null}
  return requestManager
    .get<Result<GetUserByIdOutput>>(USERS_BY_USERID_GETURL(id))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const createUserWithGroup = async (input: CreateUserWithGroupInput) => {
  const requestManager = new RequestManager()

  var res: Result<string> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .post<Result<string>>(USERS_CREATEUSERWITHGROUP_POSTURL, input)
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const updateUserInfo = async (input: UpdateUserInfoInput) => {
  const requestManager = new RequestManager()

  var res: Result<string> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .post<Result<string>>(USERS_UPDATEUSERINFO_POSTURL, input)
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const updateUserQuestions = async (input: UpdateUserQuestionsInput) => {
  const requestManager = new RequestManager()

  var res: Result<string> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .post<Result<string>>(USERS_UPDATEUSERQUESTIONS_POSTURL, input)
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}


